import { UPDATE_ENVIRONMENT } from './actions';

export const updateEnvironment = ( payload ) => ( {
  type: UPDATE_ENVIRONMENT,
  payload
} );

